// Google Drive file URL validation
// Only accepts: https://drive.google.com/file/d/{fileId}/...

const DRIVE_FILE_REGEX =
  /^https:\/\/drive\.google\.com\/file\/d\/([\w-]{25,60})(\/|$|\?)/;

export function parseDriveFileUrl(url) {
  const trimmed = (url || '').trim();

  if (!trimmed) {
    return { valid: false, fileId: null, reason: 'empty' };
  }

  if (
    trimmed.includes('drive.google.com/drive/folders/') ||
    trimmed.includes('drive.google.com/drive/u/')
  ) {
    return { valid: false, fileId: null, reason: 'folder' };
  }

  const match = trimmed.match(DRIVE_FILE_REGEX);
  if (!match) {
    return { valid: false, fileId: null, reason: 'invalid' };
  }

  return { valid: true, fileId: match[1], reason: null };
}
